'use strict';

/**
* Autocomplete settings and utilities
*/

import memoize from 'lodash.memoize'
import debounce from 'lodash.debounce'
import queryString  from 'query-string'
import {SEARCH_API_URL} from '../../urls'

const ONE_MINUTE_MS = 60*1000;

//We will setup this to allow a call ever 10 minutes
const clearCache = debounce(() => suggestionProvider.cache.clear(), 10 * ONE_MINUTE_MS);

const suggestionProvider = memoize(async (term) => {
    clearCache(); //Make sure the cache doesnt get too big
    const res= await fetch(`${SEARCH_API_URL}${term}`);
    if(!res.ok) {
        return await res.json().catch(e =>  {
            return {
                error:"Bad Response",
                query: term,
                results: [],
            };
        });
    }
    let data = await res.json();
    if (data.length>0)
        data=data[1];
    return {
        data,
    };
});

export  {
    suggestionProvider
}



// WEBPACK FOOTER //
// ./src/components/lib/autocomplete.js